import { Modal } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import {
  activateViewport,
  downloadImageFromCanvas,
  downloadSeriesFromCanvas,
  loadDownloadImageViewport,
  updateViewport,
} from "../../../helpers/CornerstoneViewportService";
import $ from "jquery";
import ImageScrollbar from "../../Scrollbar/ImageScrollbar";
import CustomSpinner from "../../../../../components/CustomSpinner";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import {
  TOAST_TYPE,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../../../constants/Constants";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import toastContext from "../../../../../context/toast/ToastContext";
import ATextField from "../../../../../components/ATextField";
import { useTranslation } from "react-i18next";

const viewportBoxStyle = {
  height: "85%",
  width: "100%",
  overflow: "hidden",
  position: "relative"
};

const viewportCanvasStyle = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
};

const DownloadImageModal = ({ downloadImageModal, setDownloadImageModal }) => {
  const { username } = useContext(userContext);
  const [t] = useTranslation();
  const { activeViewportIndex } = useContext(ViewportContext);
  const { activeThumbnailIndex } = useContext(ThumbnailContext);
  const { patientStudyData, studyData } = useContext(studyviewerContext);
  const [scrollbarHeight, setScrollbarHeight] = useState("100px");
  const [imageCount, setImageCount] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [scrollCount, setScrollCount] = useState(0);
  const [loadingState, setLoadingState] = useState(false);
  const [filename, setFilename] = useState("");
  const elementRef = useRef(null);
  const handleCancel = () => {
    setDownloadImageModal(false);
  };

  const {
    showToastv2,
    showProgressToast,
    setProgressList,
    progressList,
    updateProgress,
    hideProgress,
  } = useContext(toastContext);

  useEffect(() => {
    console.log(imageCount);
  }, [imageCount]);

  const handleDownloadSeries = async () => {
    setLoadingState(true);
    updateViewport(VIEWPORT_ROW * VIEWPORT_COLUMN + 1, 0);
    setCurrentImage(0);
    await downloadSeriesFromCanvas(
      studyData.stacks[activeThumbnailIndex].stackId,
      studyData.stacks[activeThumbnailIndex],
      imageCount,
      setLoadingState,
      setScrollCount,
      filename
    );
    logAmplitudeEventWithUsernameAndRole(
      "EVENT_BASIC_DOWNLOAD_IMAGE_USED",
      {},
      username
    );
    showToastv2(TOAST_TYPE.SUCCESS, "Series Download Successful !");
  };

  const handleDownloadImage = async () => {
    setLoadingState(true);
    console.log("filename : ", filename);
    await downloadImageFromCanvas(
      studyData.stacks[activeThumbnailIndex].stackId,
      currentImage,
      VIEWPORT_ROW * VIEWPORT_COLUMN + 1,
      filename
    );
    logAmplitudeEventWithUsernameAndRole(
      "EVENT_BASIC_DOWNLOAD_IMAGE_USED",
      {},
      username
    );
    setLoadingState(false);
    showToastv2(TOAST_TYPE.SUCCESS, "Image Download Successful !");
  };

  const PrimaryButtonList = [
    {
      title: "Download Series",
      onclick: handleDownloadSeries,
    },
    {
      title: "Download Image",
      onclick: handleDownloadImage,
    },
  ];

  const handleFileNameChange = (e) =>{
    setFilename(e.target.value);
  }

  useEffect(() => {
    setLoadingState(true);
    setTimeout(() => {
      const element = $("#download-image-viewport").find("#viewportEntry")[0];
      const sbHeight = `${elementRef.current.clientHeight - 23}px`;
      setScrollbarHeight(sbHeight);
      activateViewport(element, VIEWPORT_ROW * VIEWPORT_COLUMN + 1);
      setTimeout(() => {
        loadViewport();
      }, 2000);
    }, 1000);
  }, []);

  const loadViewport = async () => {
    setLoadingState(true);
    const maxImageCount = await loadDownloadImageViewport(
      activeViewportIndex,
      VIEWPORT_ROW * VIEWPORT_COLUMN + 1
    );
    setTimeout(() => {
      setLoadingState(false);
    }, 1000);
    setImageCount(maxImageCount);
  };

  const onChange = (event) => {
    const intValue = parseInt(event.target.value, 10);
    setCurrentImage(intValue);
    setScrollCount(intValue);
    // await updateViewport(5, intValue);
  };

  const onKeyPress = (event) => {
    const keyCode = event.which;

    switch (keyCode) {
      case 38: //UP
        if (currentImage != 0) {
          //   await updateViewport(5, currentImage - 1);
          setCurrentImage(currentImage - 1);
          setScrollCount(currentImage - 1);
        }
        break;
      case 40: //DOWN
        if (currentImage != imageCount) {
          //   await updateViewport(5, currentImage + 1);
          setCurrentImage(currentImage + 1);
          setScrollCount(currentImage + 1);
        }
        break;
    }
  };

  const onWheel = async (event) => {
    if (event.deltaY < 0 && currentImage === 0) return;
    if (event.deltaY >= 0 && currentImage === imageCount) return;
    // updateViewport(currentImage + event.deltaY / Math.abs(event.deltaY))
    setCurrentImage(currentImage + event.deltaY / Math.abs(event.deltaY));
    setScrollCount(currentImage + event.deltaY / Math.abs(event.deltaY));
  };

  useEffect(() => {
    if (currentImage !== 0) {
      updateViewport(VIEWPORT_ROW * VIEWPORT_COLUMN + 1, currentImage);
    }
  }, [currentImage]);

  const Containerstyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
    main: {
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: "1px solid rgba(255, 255, 255, 0.3)",
    },
  };

  const customSpinnerStyle = {
    padding: "auto",
    height: "100vh",
    width: "100vw",
    zIndex: "999",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    position: "fixed",
    top: "0",
    left: "0",
  };

  return (
    <>
      <Modal
        isOpen={true}
        titleAriaId="id"
        styles={Containerstyles}
        scrollableContentClassName={"stop-scroll-for-modal"}
      >
        {loadingState && <CustomSpinner />}
        <ModalHeader
          patientName={patientStudyData.patientName}
          patientID={patientStudyData.patientId}
          updatedModal={true}
          heading={t("download-image-modal.download-image-heading")}
          handleCancel={handleCancel}
        />
        <div
          style={{
            width: "785px",
            height: "550px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{ width: "100%", height: "100%", position: "relative" }}
          >
            <div style={{ height: "15%", width: "30%", marginLeft: "10px" }}>
              <ATextField
                name="filename"
                label={t("download-image-modal.filename")}
                placeholder={t("download-image-modal.enter-filename")}
                onChange={handleFileNameChange}
              />
            </div>
            <div
              className="cursor-pointer"
              id={`download-image-viewport`}
              style={viewportBoxStyle}
              onWheel={onWheel}
              onKeyDown={onKeyPress}
              ref={elementRef}
            >
              <div
                id="viewportEntry"
                style={{
                  ...viewportCanvasStyle,
                }}
              ></div>
              <ImageScrollbar
                max={imageCount}
                value={scrollCount}
                onChange={onChange}
                onKeyPress={onKeyPress}
                height={scrollbarHeight}
                elementRef={elementRef}
              />
            </div>
          </div>
        </div>
        <ModalFooter PrimaryButtonList={PrimaryButtonList} />
      </Modal>
    </>
  );
};

export default DownloadImageModal;
